import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-voucher',
  templateUrl: './voucher.component.html',
})
export class VoucherComponent {}
